import { Icon, ListItemButton, ListItemIcon, ListItemText } from '@mui/material'
import { forwardRef, useMemo } from 'react'
import {
  Link as RouterLink,
  LinkProps as RouterLinkProps,
  useLocation,
} from 'react-router-dom'

export interface SidebarListItemProps {
  title: string
  to: string
  icon?: string
  basePath?: string
  colors?: ItemColorProps
}

export interface ItemColorProps {
  color: string
  backgroundColor: string
  hoverColor: string
  hoverBackgroundColor: string
}

export const SidebarListItem = ({
  title,
  to,
  icon,
  basePath,
}: SidebarListItemProps) => {
  const location = useLocation()

  const renderLink = useMemo(
    () =>
      forwardRef<HTMLAnchorElement, Omit<RouterLinkProps, 'to'>>(
        function Link(itemProps, ref) {
          return (
            <RouterLink to={to} ref={ref} {...itemProps} role={undefined} />
          )
        },
      ),
    [to],
  )

  const isSelected = () => {
    return (
      location.pathname.startsWith(`/${to}`) ||
      location.pathname.startsWith(`${basePath}${to}`) ||
      location.pathname.startsWith(`${basePath}/${to}`)
    )
  }

  return (
    <ListItemButton
      component={renderLink}
      selected={isSelected()}
      // disableRipple
      sx={{
        height: '2.5rem',
        borderRadius: '0.375rem',
        '& .MuiListItemIcon-root': {
          color: (theme) => theme.palette.primary.main,
        },
        '&.Mui-selected': {
          backgroundColor: (theme) => theme.palette.primary.main,
          color: (theme) => theme.palette.primary.contrastText,
          '& .MuiListItemIcon-root': {
            color: (theme) => theme.palette.primary.contrastText,
          },
          '&:hover': {
            backgroundColor: (theme) => theme.palette.primary.light,
          },
        },
        '&:hover': {
          backgroundColor: (theme) => theme.palette.action.hover,
        },
      }}
    >
      <ListItemIcon
        sx={{
          minWidth: '35px',
        }}
      >
        <Icon baseClassName='material-icons-outlined'>{icon}</Icon>
      </ListItemIcon>
      <ListItemText
        primary={title}
        primaryTypographyProps={{ fontWeight: 500 }}
      />
    </ListItemButton>
  )
}
